export const colors = [
    '#000000',
    '#ffffff',
    '#ff0000',
    '#00ff00',
    '#0000ff',
    '#ffff00',
    '#ff8000',
    '#00ffff',
    '#00ff80',
    '#ff00ff',
    '#8000ff',
    '#663300',
]

export const COLORS = {
    WHITE: '#ffffff',
    BLACK: '#000000',
    GRAY: '#808080'
}
